<template>
  <div class="device-management">
    <v-row class="center device-control-bar">
      <v-col cols="2">
        <v-select
          v-model="dvrType"
          :items="dvrTypes"
          label="Device Type"
          :disabled="loading"
          outlined
          @change="setDeviceTypeQuery"
        />
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="deviceType"
          :items="deviceTypes[dvrType]"
          :disabled="loading"
          label="Device Status"
          outlined
          @change="setDeviceTypeQuery"
        />
      </v-col>
      <v-col v-if="isAssigned" cols="2">
        <v-autocomplete
          v-model="selectedOrg"
          :items="orgName"
          label="Organisations"
          item-text="name"
          :disabled="loading"
          outlined
          @change="fetchOrgNodes"
        />
        <!-- @change="getAssetsOrDevices" -->
      </v-col>
      <v-col v-if="isAssigned" cols="2">
        <v-autocomplete
          v-model="selectedGroup"
          :items="groups"
          :loading="loadingNodes"
          :disabled="loading"
          item-text="name"
          item-value="id"
          label="Group"
          outlined
        />
      </v-col>

      <v-col cols="2">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          :disabled="loading"
          single-line
          hide-details
        ></v-text-field>
      </v-col>

       <v-spacer></v-spacer>
      
      <v-col v-if="!isAssigned" cols="2">
      </v-col>
      
      <v-col cols="2" class="d-flex justify-end">
        <v-icon 
          @click="refreshDevices"
          :disabled="loading"
        >
          mdi-refresh
        </v-icon>

        <v-icon @click="downloadWrapper" :disabled="loading">
          mdi-download
        </v-icon>
      </v-col>
    </v-row>

    <ConfigPanel 
      v-if="vehicleDeviceConfig"
      :items="selectedVehicle"
      :groups="vehicleGroups"
      :org="orgId"
      :multi-device="isMultiDeivce"
      :nodes="nodes"
      :selected-contacts="selectedContacts"
      :vehicle-types="vehiType"
      @toggleModal="toggleInfoModal"
    />

    <InfoContainer
      :display="displayVehicleInfo"
      :width="600"
      :panel-heading="panelHeading"
      @closeModal="displayVehicleInfo = false"
    >
      <pvcam-wc-vehicle-config 
        :items="JSON.stringify(selectedVehicle)"
        :groups="JSON.stringify(vehicleGroups)"
        :org="JSON.stringify(orgId)"
        :vehicle-types="JSON.stringify(vehiType)"
        :nodes="JSON.stringify(nodes.root_node)"
        :multi-device="JSON.stringify(isMultiDeivce)"
        :admin="true"
        :translate="JSON.stringify(false)"
        @showSelectContacts="handleSelection"
      />
    </InfoContainer>

		<!-- <InfoContainer
      :display="displayDeviceInfo"
      :width="1000"
      :panel-heading="panelHeading"
      @closeModal="displayDeviceInfo = false"
    >
      <pvcam-wc-device-info
        :org="JSON.stringify(orgId)"
        :items="JSON.stringify(selectedVehicle)"
      />
      
    </InfoContainer> -->

    <DeviceInfo 
      v-if="displayDeviceInfo"
      :display-device-info="displayDeviceInfo"
      :vehicle="selectedVehicle[0]"
      :device-id="selectedVehicleDeviceId"
      :org="orgId"
      @close="displayDeviceInfo = false"
    />

		<InfoContainer
      :display="displayAlertConfig"
      :width="600"
      :panel-heading="panelHeading"
      @closeModal="displayAlertConfig = false"
    >
      <pvcam-wc-device-alert-config
        :items="JSON.stringify(selectedVehicle)"
        :groups="JSON.stringify(vehicleGroups)"
        :org="JSON.stringify(orgId)"
        :vehicle-types="JSON.stringify(vehiType)"
        :nodes="JSON.stringify(nodes)"
        :multi-config="JSON.stringify(displayMultiConfig)"
        :selected-contacts="JSON.stringify(selectedContacts)"
        :user-info="JSON.stringify({})"
				:admin-user="true"
      />
    </InfoContainer>
    
    <AssignedDevicesTable 
      v-if="deviceType == 'Assigned' && dvrType == 'Camera System'"
      :data="devices"
      :search="search"
      :loading="loading"
      :org="orgId"
      :pagination-info="assignedPaginationInfo"
      @unassignDevice="setUnassignTarget"
      @showInfoModal="setSelectedVehicle"
      @toggleFormat="toggleFormat"
      @toggleReboot="toggleReboot"
      @toggleDeviceConfig="toggleDeviceConfig"
      @toggleLogComp="toggleLogComp"
      @toggleJobCreation="toggleJobCreation"
      @toggleConfigComponent="toggleConfigComponent"
      @updatedPage="getDevicesByOrg"
    />
    <PendingDevicesTable 
      v-if="deviceType == 'Pending' && dvrType == 'Camera System'"
      :data="devices"
      :search="search"
      :loading="loading"
      @updateOTC="setUpdateOTCTarget"
      @deleteDevice="setDeleteDeviceTarget"
    />

    <UnassignedDevicesTable 
      v-if="deviceType == 'Unassigned' && dvrType == 'Camera System'"
      :data="devices"
      :search="search"
      :loading="loading"
      :pagination-info="unassignedPaginationInfo"
      @deleteDevice="setDeleteDeviceTarget"
      @toggleAssignmentComp="toggleAssignmentComp"
      @showUnassignedInfoModal="showInfoModal"
      @selectionUpdated="selectionUpdated"
      @toggleFormat="toggleFormat"
      @toggleReboot="toggleReboot"
      @toggleDeviceConfig="toggleDeviceConfig"
      @updatedPage="getUnassignedDevicesList"
    />

    <UnassignedAssetsTable
      v-if="deviceType == 'Unassigned' && dvrType == 'Asset Tracker'"
      :data="devices"
      :search="search"
      :loading="loading"
      :clear-selection="clearSelection"
      @toggleAssetAssignmentComp="toggleAssetAssignmentComp"
      @toggleAssetConfig="toggleAssetConfig"
      @selectionUpdatedAssets="selectionUpdatedAssets"
      @showAssetConfig="showAssetDeviceConfig = true"
    />

    <AssignedAssetsTable
      v-if="deviceType == 'Assigned' && dvrType == 'Asset Tracker'"
      :data="devices"
      :search="''"
      :loading="loading"
      :presence="assetPresence"
      :pagination-info="assignedAssetsPaginationInfo"
      @selectionUpdatedAssets="selectionUpdatedAssets"
      @toggleEditAsset="toggleEditAsset"
      @toggleDeviceInfo="toggleDeviceInfo"
      @toggleMoveAsset="displayMoveAsset = true"
      @unassignAssetDevice="showUnassignAsset = true"
      @showLocation="showAssetLocation = true"
      @showAssetConfig="showAssetDeviceConfig = true"
    />

    <DeviceAssignment
      v-if="showDeviceAssignment"
      :orgs="orgs"
      :selected-devices="selectedDevices"
      @closeDeviceAssignment="toggleAssignmentComp"
      @deviceSelectedForInstall="deviceSelectedForInstall"
      @closeAllAssignmentWindows="toggleAssignmentComp"
      @refresh="getUnassignedDevicesList"
    />

    <!-- Unassign Device prompt message -->
    <Prompt
      :display="displayUnassignPrompt"
      :close-target="'closeUnassign'"
      :submit-target="'submitUnassign'"
      :title="'Unassign Device'"
      :message="'Are you sure you wish to unassign this device?'" 
      :state="unassignState"
      :res="unassignRes"
      @closeUnassign="toggleUnassignPrompt"
      @submitUnassign="unassignDevice"
    />

    <!-- Update OTC prompt message -->
    <Prompt
      :display="displayUpdateOTC"
      :close-target="'closeUpdateOTC'"
      :submit-target="'submitUpdateOTC'"
      :title="'Update OTC'"
      :message="'Are you sure you wish to update the OTC?'" 
      :state="updateState"
      :res="updateRes"
      @closeUpdateOTC="toggleUpdateOTC"
      @submitUpdateOTC="regenOTC"
    />

    <!-- Delete device prompt message -->
    <Prompt
      :display="displayDeleteDevice"
      :close-target="'closeDeleteDevice'"
      :submit-target="'submitDeleteDevice'"
      :title="'Delete Device'"
      :message="'Are you sure you wish to delete this device?'"
      :state="deleteState" 
      :res="deleteRes"
      @closeDeleteDevice="toggleDeleteDevicePrompt"
      @submitDeleteDevice="deleteDevice"
    />

    <DeviceFormat 
			v-if="displayFormat"
			:device="formatItem"
			:org="orgId"
			@close="toggleFormat(null)"
    />
    
    <DeviceReboot 
			v-if="displayReboot"
			:org="orgId"
			:device="rebootDevice"
			@close="toggleReboot(null)"
		/>

    <DeviceConfig 
			v-if="displayDeviceConfig"
      :key="compKey"
			:item="selectedDevice"
			:org="orgId"
      :device-id="selectedDevice.id"
      @closeDeviceConfig="displayDeviceConfig = !displayDeviceConfig"
      @forceUpdateConfig="handleForceUpdate"
    />

    <DownloadLog 
			:display="showLogs"
			:device="logItem" 
			:org="orgId"
			@closeLogComp="closeLogComp"
		/>

    <add-job 
      :key="refreshAddJob"
			:open="jobVisibility" 
			:mode="'new'" 
			:job-item="jobItem"
			@exit="toggleJobCreation(null)"
		/>

    <Dialog
      :display="showAssetAssignment"
      :title="'Assign Asset Tracker to Organisation'"
      :state="false" 
      :width="1200"
      @close="toggleAssetAssignmentComp"
    >
      <AssetAssignment
        v-if='showAssetAssignment && selectedAssets.length > 0'
        :display="showAssetAssignment"
        :assets="selectedAssets"
        :orgs="orgs"
        :default-org="orgId"
        @close="toggleAssetAssignmentComp"
        @refresh="refreshDevices"
      />
    </Dialog>

    <Dialog 
      v-if='showEditAsset && selectedAssets.length > 0'
      :display="showEditAsset"
      :title="'Edit Asset'"
      :state="false" 
      :res="{}"
      @close="toggleEditAsset"
    >
      <v-row class="pb-0">
        <v-col cols="4" class="pb-0 pt-0">
          Name
        </v-col>
        <v-col cols="8" class="pb-0 pt-0">
          <v-text-field v-model="editAssetPayloadObj.name"/>
        </v-col>
      </v-row>

      <v-row class="pb-0 pt-0">
        <v-col cols="4" class="pb-0 pt-0">
          Type
        </v-col>
        <v-col cols="8" class="pb-0 pt-0">
          <v-select 
            v-model="editAssetPayloadObj.asset_type"
            :items="assetTypes"
          />
        </v-col>
      </v-row>

      <v-row class="pb-0 pt-0">
        <v-col cols="4" class="pb-0 pt-0">
          Make
        </v-col>
        <v-col cols="8" class="pb-0 pt-0">
          <v-text-field v-model="editAssetPayloadObj.make"/>
        </v-col>
      </v-row>

      <v-row class="pb-0 pt-0">
        <v-col cols="4" class="pb-0 pt-0">
          Model
        </v-col>
        <v-col cols="8" class="pb-0 pt-0">
          <v-text-field v-model="editAssetPayloadObj.model"/>
        </v-col>
      </v-row>

      <v-row class="pb-0 pt-0">
        <v-col cols="4" class="pb-0 pt-0">
          Year
        </v-col>
        <v-col cols="8" class="pb-0 pt-0">
          <v-text-field v-model="editAssetPayloadObj.year"/>
        </v-col>
      </v-row>

      <v-row class="pb-0 pt-0">
        <v-col cols="4" class="pb-0 pt-0">
          Group
        </v-col>
        <v-col cols="8" class="pb-0 pt-0">
          <v-select 
            v-model="editAssetPayloadObj.node_id"
            :items="vehicleGroups"
            item-value="id"
            item-text="name"
          />
        </v-col>
      </v-row>

      <v-row class="pb-0 pt-0">
        <v-col cols="4" class="pb-0 pt-0">
          Notes
        </v-col>
        <v-col cols="8" class="pb-0 pt-0">
          <v-textarea v-model="editAssetPayloadObj.notes"/>
        </v-col>
      </v-row>

      <v-row class="pb-0 pt-0">
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-btn text color="primary" @click="toggleEditAsset">cancel</v-btn>
        </v-col>
        <v-col cols="2">
          <v-btn text color="primary" :loading="updatingAsset">Submit</v-btn>
        </v-col>
      </v-row>
    </Dialog>

    <Dialog 
      v-if="selectedDevice && firstAssetInSelection"
      :display="showDeviceInfo"
      :title="'Device Information'"
      :state="false" 
      :res="{}"
      @close="toggleDeviceInfo"
    >
      <div class="pa-2">
        <v-row class="pb-1 pt-1 grey-bg pr-0">
          <v-col cols="6" class="pb-0 pt-0">
            Serial Number
          </v-col>
          <v-col cols="4" class="pb-0 pt-0 device-label">
            {{ firstAssetInSelection.serial_number }}
          </v-col>
        </v-row>

        <v-row class="pb-1 pt-1 pr-0">
          <v-col cols="6" class="pb-0 pt-0">
            IMEI
          </v-col>
          <v-col cols="4" class="pb-0 pt-0 device-label">
            {{ firstAssetInSelection.imei }}
          </v-col>
        </v-row>

        <v-row class="pb-1 pt-1 grey-bg pr-0">
          <v-col cols="6" class="pb-0 pt-0">
            SIM ICCID
          </v-col>
          <v-col cols="4" class="pb-0 pt-0 device-label">
            {{ firstAssetInSelection.iccid }}
          </v-col>
        </v-row>

        <v-row class="pb-1 pt-1 pr-0">
          <v-col cols="6" class="pb-0 pt-0">
            Model
          </v-col>
          <v-col cols="4" class="pb-0 pt-0 device-label">
            {{ firstAssetInSelection.device_model }}
          </v-col>
        </v-row>

        <v-row class="pb-1 pt-1 grey-bg pr-0">
          <v-col cols="6" class="pb-0 pt-0">
            Firmware Version
          </v-col>
          <v-col cols="4" class="pb-0 pt-0 device-label">
            {{ firstAssetInSelection.firmware_version }}
          </v-col>
        </v-row>
      </div>

      
    </Dialog>

    <MoveAssetsBetweenOrgs
      v-if="displayMoveAsset"
      :orgs="orgs"
			:asset-list="selectedAssets"
			@close="displayMoveAsset = false"
    />

    <Dialog 
      :display="showUnassignAsset"
      :title="'Unassign Device'"
      :state="false" 
      :width="600"
      :res="{}"
      @close="showUnassignAsset = false"
    >
      <v-row>
        <v-col cols="2" class="text-center pr-0">
          <v-icon size="60" color="orange">
            mdi-alert
          </v-icon>
        </v-col>
        <v-col v-if="selectedAssets.length == 1" cols="10" class="pl-0">
          The device will be unassigned from the asset and returned to the unassigned device pool. Are you sure you want to proceed?
        </v-col>
        <v-col v-else cols="10" class="pl-0">
          {{selectedAssets.length}} devices will be unassigned from their assets and returned to the unassigned device pool. Are you sure you want to proceed?
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-btn text color="#0f74bb" @click="showUnassignAsset = false" >
            no
          </v-btn>
        </v-col>
        <v-spacer/>
        <v-col cols="2">
          <v-btn text color="#0f74bb" :loading="unassigningAssets" @click.native="unassignAssetFromDevice">
            yes
          </v-btn>
        </v-col>
      </v-row>
    </Dialog>

    <Dialog 
      :display="showAssetLocation"
      :title="assetLocationTitle"
      :state="false" 
      :width="900"
      :res="{}"
      @close="showAssetLocation = false"
    >

      <div v-if="assetLocation && showAssetLocation" class="asset-map">
        <pvcam-wc-map-simple v-if="assetLocation && showAssetLocation" width="100%" height="100%"></pvcam-wc-map-simple>
      </div>
    
    </Dialog>

    <Dialog 
      :display="showAssetDeviceConfig"
      :title="assetConfigTitle"
      :state="false" 
      :width="1000"
      :res="{}"
      @close="showAssetDeviceConfig = false"
    >

      <AssetConfig
        v-if="showAssetDeviceConfig"
        :asset-list="selectedAssets"
        :org="orgId"
        @close="showAssetDeviceConfig = false"
      />
    </Dialog>
  </div>
</template>

<script>

import { getCoor } from "@/utils"

const { CameraMatics } = window;

import { 
  GetOrgDevices, 
  GetOrgTree, 
  GetPendingDevicesByOrg,
  GetUnassignedDevices, 
  UnassignDeviceFromVehicle,
  RegenerateOTC,
  DeletePendingDevice,
  DeleteUnassignedDevice,
  getUnassignedAssets,
  getOrgAssetsPresense,
  getOrgAssetDevices,
  getOrgAssetDevicesByNode,
  unassignAssetFromDevice,
  GetOrgDevicesByNode,
  SearchOrgDevices,
  SearchOrgAssetDevices
  // SearchUnassignedDevices
  } from '@/services/API.js';

import { mapState, mapActions, mapMutations } from "vuex";
import AssignedDevicesTable from './components/AssignedDevicesTable.vue';
import PendingDevicesTable from './components/PendingDevicesTable.vue';
import UnassignedDevicesTable from './components/UnassignedDevicesTable.vue';
import UnassignedAssetsTable from './components/UnassignedAssetsTable.vue';
import AssignedAssetsTable from './components/AssignedAssetsTable.vue';
import DeviceAssignment from './components/DeviceAssignment.vue';
import ConfigPanel from './components/ConfigPanel.vue';
import Prompt from '@/components/general/Prompt.vue';
import DeviceFormat from '@/components/general/DeviceFormat.vue';
import DeviceReboot from '@/components/general/DeviceReboot.vue';
import DeviceConfig from '@/components/deviceConfig/config.vue';
import DownloadLog from '@/views/OrgVehicles/components/DownloadLog.vue';
import AddJob from "@/views/Jobs/Sections/AddJob.vue";
import InfoContainer from '@/components/general/InfoContainer.vue';
import DeviceInfo from '@/components/deviceInfo/deviceInfo.vue';
import Dialog from '@/components/general/Dialog.vue';
import AssetAssignment from './components/AssetAssignment.vue';
import MoveAssetsBetweenOrgs from '@/components/general/MoveAssetsBetweenOrgs'
import AssetConfig from '@/components/assetConfig/config.vue';
import { presence } from '@/mixins/presence'

import moment from "moment";
import xlsx from 'xlsx';

import { Logger } from "aws-amplify"
const logger = new Logger("Device Management")

export default {
  name: 'DeviceManagement',
  mixins: [ presence ],
  components: {
    AssignedDevicesTable,
    UnassignedDevicesTable,
    PendingDevicesTable,
    DeviceAssignment,
    ConfigPanel,
    DownloadLog,
    Prompt,
    DeviceFormat,
    DeviceReboot,
    DeviceConfig,
    AddJob,
    InfoContainer,
    DeviceInfo,
    UnassignedAssetsTable,
    Dialog,
    AssetAssignment,
    AssignedAssetsTable,
    MoveAssetsBetweenOrgs,
    AssetConfig
  },
  data() {
    return {
      compKey: 0,
      search: '',
      availableTags: [],
      devices: [],
      assets: [],
      selectedOrg: '',
      loading: false,
      deviceType: '',
      deviceTypes: {
        'Camera System': [
          'Assigned',
          'Unassigned',
          'Pending'
        ],
        'Asset Tracker': [
          'Assigned',
          'Unassigned'
        ]
      },
      dvrTypes: [
        'Camera System',
        'Asset Tracker'
      ],
      dvrType: 'Camera System',
      vehicles: [],
      showDeviceAssignment: false,
      vehicleDeviceConfig: false,
      selectedVehicleDevice: [],
      selectedVehicle: [],
      nodes: {},
      vehicleGroups: [],
      displayUnassignPrompt: false,
      unassignTarget: {},
      displayUpdateOTC: false,
      updateOTCTarget: {},
      displayDeleteDevice: false,
      deleteDeviceTarget: {},
      selectedDevices: [],
      selectedDevice: {},
      unassignState: false,
      unassignRes: null,
      updateState: false,
      updateRes: null,
      deleteState: false,
      deleteRes: null,
      displayDeviceConfig: false,
      tableHeadings: {
        Unassigned: {
          headers: [
            {
              text: 'OTC',
              value: 'otc',
              align: 'left'
            },
            {
              text: 'Install Tag',
              value: 'install_tag',
              align: 'left'
            },
            {
              text: 'IMEI',
              value: 'imei',
              align: 'left'
            },
            {
              text: 'Model',
              value: 'model',
              align: 'left'
            },
            {
              text: 'Firmware Version',
              value: 'firmware',
              align: 'left'
            },
            {
              text: 'Actions',
              value: 'actions',
              align: 'left'
            }
          ]
        },
        Assigned: {
          headers: [
            {
              text: 'IMEI',
              value: 'imei',
              align: 'left'
            },
            {
              text: 'Vehicle',
              value: 'vehicle',
              align: 'left'
            },
            {
              text: 'Model',
              value: 'model',
              align: 'left'
            },
            {
              text: 'Firmware',
              value: 'firmware',
              align: 'left'
            },
            {
              text: 'Actions',
              value: 'actions',
              align: 'left'
            }
          ]
        },
        Pending: {
          headers: [
            {
              text: 'OTC',
              value: 'Profile.otc',
              align: 'left'
            },
            {
              text: 'Org Tag',
              value: 'org',
              align: 'left'
            },
            {
              text: 'Actions',
              value: 'actions',
              align: 'left'
            }
          ]
        }
      },

      displayFormat: false,
			formatItem: null,
      
      displayReboot: false,
			rebootDevice: null,
      selectedContacts: [],

      showLogs: false,
      logItem: {},

      jobVisibility: false,

      jobItem: null,
      refreshAddJob: 0,
      
      displayVehicleInfo: false,
			displayDeviceInfo: false,
			displayAlertConfig: false,
			multiDevices: false,
			displayMultiConfig: false,
      selectedAssets: [],
      showAssetAssignment: false,
      assetPresence: {},
      itemsPerPage: 50,
      totalPages: 1,
      page: 1,

      editAssetPayloadObj: {
        "name": '',
        "asset_id": '',
        "asset_type": '',
        "make": '',
        "model": '',
        "year": '',
        "node_id": '',
        "notes": '',
      },
      editAssetPayloadList: [],
      showEditAsset: false,
      updatingAsset: false,
      assetTypes: [
        'Trailer'
      ],

      showDeviceInfo: false,

      displayMoveAsset: false,

      showUnassignAsset: false,
      unassigningAssets: false,

      showAssetLocation: false,

      showAssetDeviceConfig: false,

      clearSelection: 0,

      groups: [],
      selectedGroup: '',
      loadingNodes: false,

      assignedPaginationInfo: {
        pageNum: 1,
        pageCount: 1,
        rowsPerPage: 50
      },

      pendingPaginationInfo: {
        pageNum: 1,
        pageCount: 1,
        rowsPerPage: 50
      },

      unassignedPaginationInfo: {
        pageNum: 1,
        pageCount: 1,
        rowsPerPage: 50
      },

      assignedAssetsPaginationInfo: {
        pageNum: 1,
        pageCount: 1,
        rowsPerPage: 50
      },

      searchTermTimeout: false,
      lastSearchAbove3Characters: false, 
    }
  },
  computed: {
    ...mapState([
      'vehiType',
      'orgs'
    ]),
    isMultiDeivce() {
      return this.selectedVehicle.length > 1 ? true : false;
    },
    sortedOrgs() {
      return [...this.orgs].sort((a, b) => a.name.localeCompare(b.name));
    },
    orgName() {
      	const orgs = this.sortedOrgs.map((org) => ({
					name: org.name
				}));

        return orgs;
    },
    orgId() {
      return this.retrunOrgID(this.selectedOrg);
    },
    isAssigned() {
      return this.deviceType != 'Unassigned' ? true : false;
    },
    panelHeading() {
      return this.selectedVehicle.length > 0 
        ? this.selectedVehicle.length > 1 ? 'Multiple Vehicles Selected' : this.selectedVehicle[0].vehicle_name
        :
        '';
    },
    selectedVehicleDeviceId() {
      const vehicle = this.selectedVehicle.length > 0 ? this.selectedVehicle[0] : null
      const devices = Object.hasOwn(vehicle, 'devices') && vehicle.devices.length > 0 ? vehicle.devices : []
      const defaultDevice = devices.length > 0 ? devices.find(device => device.is_defaultdevice == true) : null
      const deviceId = defaultDevice ? defaultDevice.device_id : ''

      return deviceId
    },
    firstAssetInSelection() {
      return this.selectedAssets.length > 0 ? this.selectedAssets[0] : null
    },

    lastSelectedAsset() {
      if(!this.selectedAssets) return
      const total = this.selectedAssets.length

      return this.selectedAssets.length > 0 ? this.selectedAssets[total - 1] : null
      
    },

    assetLocation() {
      if(!this.lastSelectedAsset) return
      if(this.lastSelectedAsset.length <= 0 || !this.lastSelectedAsset) return false

      if(Object.hasOwn(this.assetPresence, this.lastSelectedAsset.asset_id)) {
        return this.assetPresence[this.lastSelectedAsset.asset_id]['coords']
      } 
      else {
        return false
      }
    },

    selectedAssetsIds() {
      return this.selectedAssets.map(asset => asset.asset_id)
    },

    assetConfigTitle() {
      const assetCount = this.selectedAssets.length

      if (assetCount == 0) {
        return
      }
      if (assetCount == 1) {
        return `Device Configuration IMEI ${this.lastSelectedAsset.imei}, SERIAL ${this.lastSelectedAsset.serial_number}`
      }
      else {
        const remaining = this.selectedAssets.length - 1

        return `Device Configuration IMEI ${this.lastSelectedAsset.imei}, SERIAL ${this.lastSelectedAsset.serial_number} + ${remaining} others`
      }
    },

    assetLocationTitle() {
      return this.assetLocation ? `Asset Location: ${this.lastSelectedAsset.asset_name}, ${this.formatDate(this.readValueFromPresenceMap(this.lastSelectedAsset, 'last_seen'))}` : ''
    }
   },
  watch: {
    deviceType() {
      // Reset devices table contents upon changing device type e.g assigned, unassignd...
      this.devices = [];
    },

    dvrType() {
      // Reset devices table contents upon changing device type e.g assigned, unassignd...
      this.devices = [];
    },

    selectedOrg (val) {
      if(val) {
        // const id = this.retrunOrgID(val);
      }
    },

    showAssetLocation(val) {
      if(val) {
        setTimeout(() => {
          this.showLocation(this.assetLocation)
        }, 750)
      }
    },
    
    selectedGroup() {
      this.getAssetsOrDevices()
    },

    search(val) {
      if(this.deviceType == 'Unassigned') return

      if (this.searchTermTimeout) {
        clearTimeout(this.searchTermTimeout)
      }
      
      // if our string is above two characters, lets set a timeout to load the vehicles with the new search term
      if(val.length > 2) {
        this.searchTermTimeout = setTimeout(() => {
          if(this.dvrType == 'Asset Tracker') {
            this.searchAssets()
          }
          else {
            this.searchDevices()
          }
          
          this.lastSearchAbove3Characters = true
          this.searchTermTimeout = false
        }, 1500)
      
      // if the user has dropped below 3 characters in the search, we have to search without a search term
      } else if(this.lastSearchAbove3Characters) {
          this.searchTermTimeout = setTimeout(() => {
          if(this.dvrType == 'Asset Tracker') {
            this.searchAssets()
          }
          else {
            this.searchDevices()
          }
          this.lastSearchAbove3Characters = false
          this.searchTermTimeout = false
        }, 1500)
      }
    }
  },
  beforeMount() {
    this.getVehiType();
  },
  mounted() {
    //  Preselect device type dropdown
    this.deviceType = 'Assigned'
    this.getOrgs();
    window.$translate = (section, value) => {
      logger.info('translate', section, value)
    }
  },
  methods: {
    ...mapActions(["getOrgs", "getVehiType"]),

    showLocation (location) {

      if(location) {
        try {
          window.EventBus.$emit("showEvent", {
            coor: location,
            icon: 'trailer',
            content: false
          })
        } 
        
        catch (error) {
            logger.debug("event error", error)
        }
      }
    },

    toggleDeviceInfo(item) {
      if(item) {
        this.selectedItemId = item.asset_id
      }

      this.showDeviceInfo = !this.showDeviceInfo
    },

    toggleEditAsset() {
      this.showUpdateError = false
      this.editAssetPayloadList = []
      let masterAsset = {}

      if(this.selectedAssets.length > 0) {
        masterAsset = this.selectedAssets[0]

        this.editAssetPayloadObj.name = masterAsset.asset_name
        this.editAssetPayloadObj.asset_id = masterAsset.asset_id
        this.editAssetPayloadObj.asset_type = masterAsset.asset_type
        this.editAssetPayloadObj.make = masterAsset.asset_make
        this.editAssetPayloadObj.model = masterAsset.asset_model
        this.editAssetPayloadObj.year = masterAsset.asset_year
        this.editAssetPayloadObj.node_id = masterAsset.node
        this.editAssetPayloadObj.notes = masterAsset.notes
      }

      for(const asset in this.selectedAssets) {
        logger.info('asset?', this.selectedAssets[asset])

        this.editAssetPayloadList.push({
          'name': masterAsset.asset_name,
          'asset_id': this.selectedAssets[asset].asset_id,
          'asset_type': masterAsset.asset_type,
          'make': masterAsset.asset_make,
          'model': masterAsset.asset_model,
          'year': masterAsset.asset_year,
          'node_id': masterAsset.node,
          'notes': masterAsset.notes,
        })
      }
      
      this.showEditAsset = !this.showEditAsset
    },

    findLocations (dataSet, propetyName = "location") {
      return new Promise(async (res, rej) => { 
        try {
          let coords = dataSet.map((i, index) => {
            i.arrayPos = index
            i.coords = { lat: getCoor(i.last_location.coords.lat), lng: getCoor(i.last_location.coords.long)}
            return i
          })

          // we want no run all of these requests async so we map each request to a promise
          const promises = coords.map(i => new Promise(async (res) => {
            try {
              const location = await CameraMatics.HereMapService.multiRevGeocode([i.coords])
              // if we can find the location
              if(location.Response) {
                coords[i.arrayPos][propetyName] = location.Response.Item[0].Result[0].Location.Address.Label
                res(true)
              // if we can't find the location
              } else {
                coords[i.arrayPos][propetyName] = 'Unknown'
                res(true)
              }
            // if something goes wrong, we just set the location as not known!
            } catch (exception) {
              coords[i.arrayPos][propetyName] = 'Unknown'
              res(true)
            }
          }))

          // wait for all requests to finish the return the ammended set
          await Promise.all(promises)
          res(coords)

        } catch (ex) {
          logger.debug("error finding locations", ex)
          rej(false)
        }
      })
    },
  
    /**
     * 
     * @param page page to load
     * @param rows rows per page
     */
    async getDevicesByOrg(page = 1, rows = this.assignedPaginationInfo.rowsPerPage) {
      logger.info('getDevicesByOrg', page, rows)
      if(!this.orgId || !this.selectedGroup) return
      
      this.loading = true
      this.vehicles = []
      this.devices = []

      // this.resetStatusCount();
      // this.manualRefresh();

      try {
        let devices;
        let vehicles = {}

        if (this.deviceType == 'Assigned') {
          devices = await GetOrgDevicesByNode(this.orgId, this.selectedGroup, page, rows)
          let vehiclesToRequest = devices.Devices.map(i => i.trackable_id).filter(i => i)
          vehicles = {
            Vehicles: await this.$loadVehicles(this.orgId, vehiclesToRequest)
          }
          logger.debug("vehicles fetched", vehicles.Vehicles)

        } else if (this.deviceType == 'Pending') {
          devices = await GetPendingDevicesByOrg(this.orgId);

          this.devices = devices.Devices
          this.loading = false         
        }
        

        if(vehicles && Object.hasOwn(vehicles, 'Vehicles') && devices && Object.hasOwn(devices, 'Devices')) {
          this.devices = devices.Devices
          this.vehicles = vehicles.Vehicles

          if (this.deviceType == 'Assigned') {
            logger.info('assigned paging ', devices)
            this.assignedPaginationInfo.pageNum = devices.page_num;
            this.assignedPaginationInfo.pageCount = devices.total_pages;
            this.assignedPaginationInfo.rowsPerPage = rows
          }

          // TODO: Add paging support for pending devices when API has required info
          // if (this.deviceType == 'Pending') {
          //   this.pendingPaginationInfo.pageNum = devices.page_num;
          //   this.pendingPaginationInfo.pageCount = devices.total_pages;
          // }
          
          this.loading = false
        }
      }
      catch {
        this.loading = false
        throw new Error('An error occurred while requesting devices list')
      }
    },

    async searchDevices() {
      this.loading = true
      this.vehicles = []
      this.devices = []

      const device_type = this.deviceType.toLowerCase()
      let search
      if(this.deviceType == 'Assigned' || this.deviceType == 'Pending') {
        if(!this.orgId || !this.selectedGroup) return
      }
      if(device_type == 'unassigned') {
        return
      }
      else {
        search = await SearchOrgDevices(this.orgId, this.selectedGroup, this.search, device_type)
      }
      

      if(Object.hasOwn(search, 'Devices') && Object.hasOwn(search, 'page_num') && Object.hasOwn(search, 'total_pages')) {
        
        this.devices = search.Devices;
        let vehiclesToRequest = search.Devices.map(i => i.trackable_id).filter(i => i)
        let vehicles = {
          Vehicles: await this.$loadVehicles(this.orgId, vehiclesToRequest)
        }
        this.vehicles = vehicles.Vehicles
        logger.info('vehiclesToRequest', vehiclesToRequest)
    
        /*
        const rowOptions = [
          20,
          50,
          100,
          200
        ]
        const targetPageSize = search.page_size
        const output = rowOptions.reduce((prev, curr) => Math.abs(curr - targetPageSize) < Math.abs(prev - targetPageSize) ? curr : prev);
        */

        if(this.deviceType == 'Assigned') {
          this.assignedPaginationInfo.pageNum = search.page_num;
          this.assignedPaginationInfo.pageCount = search.total_pages;
          //this.assignedPaginationInfo.rowsPerPage = output (rows per page should only change when we select a new value in the pagination control, api response does not matter)
        }

        if(this.deviceType == 'Unassigned') {
          this.unassignedPaginationInfo.pageNum = search.page_num;
          this.unassignedPaginationInfo.pageCount = search.total_pages;
          //this.unassignedPaginationInfo.rowsPerPage = output (rows per page should only change when we select a new value in the pagination control, api response does not matter)
        }

        if(this.deviceType == 'Pending') {
          this.pendingPaginationInfo.pageNum = search.page_num;
          this.pendingPaginationInfo.pageCount = search.total_pages;
          //this.pendingPaginationInfo.rowsPerPage = output (rows per page should only change when we select a new value in the pagination control, api response does not matter)
        }
      }

      this.loading = false;

      logger.info('search...', search)
    },

    async searchAssets() {
      logger.info('searchAssets', this.deviceType)
      this.loading = true
      this.vehicles = []
      this.devices = []

      const device_type = this.deviceType.toLowerCase()
      let search
      if(this.deviceType == 'Assigned' || this.deviceType == 'Pending') {
        if(!this.orgId || !this.selectedGroup) return
      }
      if(device_type == 'unassigned') {
        return
      }
      else {
        logger.info('SearchOrgAssetDevices')
        search = await SearchOrgAssetDevices(this.orgId, this.selectedGroup, this.search)
        logger.info('search', search)
      }
      

      if(Object.hasOwn(search, 'results') && Object.hasOwn(search, 'page_num') && Object.hasOwn(search, 'total_pages')) {
        
        this.devices = this.mapAssetDeviceResponse(search.results)
        let vehiclesToRequest = search.results.map(i => i.trackable_id).filter(i => i)
        let vehicles = {
          Vehicles: await this.$loadVehicles(this.orgId, vehiclesToRequest)
        }
        this.vehicles = vehicles.Vehicles
        logger.info('vehiclesToRequest', vehiclesToRequest)
        
        /*
        const rowOptions = [
          20,
          50,
          100,
          200
        ]
        const targetPageSize = search.page_size
        const output = rowOptions.reduce((prev, curr) => Math.abs(curr - targetPageSize) < Math.abs(prev - targetPageSize) ? curr : prev);
        */

        if(this.deviceType == 'Assigned') {
          this.assignedPaginationInfo.pageNum = search.page_num;
          this.assignedPaginationInfo.pageCount = search.total_pages;
          // this.assignedPaginationInfo.rowsPerPage = ouput (rows per page should only change when we select a new value in the pagination control, api response does not matter)
        }

        if(this.deviceType == 'Unassigned') {
          this.unassignedPaginationInfo.pageNum = search.page_num;
          this.unassignedPaginationInfo.pageCount = search.total_pages;
          // this.unassignedPaginationInfo.rowsPerPage = output (rows per page should only change when we select a new value in the pagination control, api response does not matter)
        }

        if(this.deviceType == 'Pending') {
          this.pendingPaginationInfo.pageNum = search.page_num;
          this.pendingPaginationInfo.pageCount = search.total_pages;
          // this.pendingPaginationInfo.rowsPerPage = output (rows per page should only change when we select a new value in the pagination control, api response does not matter)
        }
      }

      this.loading = false;

      logger.info('search...', search)
    },

    toggleConfigComponent(item, display) {
      logger.info(item, display)
      const vehicle = this.vehicles.find((vehicle) => {
        return vehicle.devices.some((device) => {
          return device.device_id === item.id;
        });
      });
      const selectedAmount = this.selectedVehicle.length;
      const displayBoolMap = {
        vehicle: this.displayVehicleInfo,
        device: this.displayDeviceInfo,
        alert: this.displayAlertConfig
      }

      if (vehicle) {
        if(!this.selectedVehicle.includes(vehicle)) {
          if(vehicle && Object.hasOwn(vehicle, 'node_name')) {
            vehicle.group = vehicle.node_name
          }
          this.selectedVehicle = [vehicle];
        }
      } else {
        // Clear selection for single select
        if (selectedAmount === 1 && displayBoolMap[display]) {
          this.selectedVehicle = [];
        }
      }

      switch (display) {
        case 'vehicle': {
          this.displayVehicleInfo = !this.displayVehicleInfo;

          break;
        }
        case 'device': {
          this.displayDeviceInfo = !this.displayDeviceInfo;

          break;
        }
        case 'alert': {
          this.displayAlertConfig = !this.displayAlertConfig;

          break;
        }
      }
    },
    ...mapMutations('presence', ['setOrgToWatch']),
    toggleJobCreation(item) {
        this.refreshAddJob++;
				this.jobVisibility = !this.jobVisibility;

				if(!item) return;
        
        const vehicle = this.vehicles.find(vehicle => {
          return vehicle.devices.some((device) => {
            return device.device_id == item.id;
          });
        })

        this.jobItem = vehicle;
			},
    handleSelection(selection, target) {
      this.selectedContacts = {
        users: selection,
        context: target
      };
    },
    handleForceUpdate() {
      this.compKey++;
    },
    batchDeviceRequest (id) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async res => {
        try {
          // we need some arbitrary limit to prevent loading forever
          const maxPages = 10
          let currentPage = 0
          let more = true
          let fullList = []
          while(currentPage < maxPages && more) {
            let list = await GetOrgDevices(id, `page_num=${currentPage}&rows_per_page=1000&order_by=id`)
            if(list && list.Devices && Array.isArray(list.Devices) && list.Devices.length) {
              fullList = fullList.concat(list.Devices)

              if(list.Devices.length < 1000) {
								more = false
							}
            } else {
              more = false
            }
            currentPage++
          }
          res({Devices: fullList})
        } catch {
          res([])
        }  
      }) 
    },
    closeLogComp() {
      this.showLogs = false;
    },
    toggleLogComp(item) {
      const vehicle = this.vehicles.find((vehicle) => {
        return vehicle.devices.some((device) => {
          return device.device_id === item.id;
        });
      })
      this.showLogs = !this.showLogs;
      this.logItem = vehicle;
    },
    toggleDeviceConfig(item) {
      logger.info('toggleDeviceConfig called', item)
      this.selectedDevice = item;
      this.displayDeviceConfig = !this.displayDeviceConfig;
    },
    toggleAssetConfig() {

    },
    toggleFormat(item) {
      this.displayFormat = !this.displayFormat;

      if (item) {
        // We have to create these new properties on the object so that it remains compatible with the vehicles page
        let devices = [{
          is_defaultdevice: true,
          device_id: item.id
        }];

        item.devices = devices;
      }
      this.formatItem = item;
    },
    toggleReboot(item) {
      this.displayReboot = !this.displayReboot;

      if (item) {
        // We have to create these new properties on the object so that it remains compatible with the vehicles page
        let devices = [{
          is_defaultdevice: true,
          device_id: item.id
        }];

        item.devices = devices;
      }

      this.rebootDevice = item;
    },

    async setDeviceTypeQuery() {
      logger.info('setDeviceTypeQuery', this.deviceType, this.dvrType)
      if(this.dvrType == 'Camera System') {
        if (this.deviceType == 'Unassigned') {
          logger.info('unassign camera')
          await this.getUnassignedDevicesList(1);
        }
        else {
          if (this.selectedOrg.length > 0) {
            this.getDevicesByOrg();
          }
        }
      }
      else {
        if (this.deviceType == 'Unassigned') {
          await this.getUnassignedAssets()
        }
        else {
          if (this.selectedOrg.length > 0) {
            this.getAssetsByOrg()
          }
        }
      }
    },

    downloadWrapper() {
      if(this.dvrType == 'Camera System') {
        this.downloadFile()
      }
      else {
        if (this.deviceType == 'Unassigned') {
          this.downloadUnassignedAssets()
        }
        else {
          if (this.selectedOrg.length > 0) {
            this.downloadAssignedAssets()
          }
        }
      }
    },

    async getAllOrgAssets() {
      const allResults = [];
      let currentPage = 1

      for (let i = 0; i < this.totalPages; i++) {
        try {
          currentPage = i + 1;
          const assets = await getOrgAssetDevices(this.orgId, currentPage, this.itemsPerPage) 

          if (!assets) {
            throw new Error(`Request failed`);
          }
          const data = await assets.results

          if (Array.isArray(data)) {
            allResults.push(...data);
          } else {
            throw new Error(`Result is not array ${assets.results}`);
          }
        } catch (error) {
          throw new Error(`Error during API call ${i + 1}:`, error);
        }
      }

      return allResults;
    },

    formatDate(val) {
      if(!val) return ''
      return moment(val).format('DD MMM YYYY HH:mm:ss')
    },

    async downloadUnassignedAssets() {
      const exportSheetName = `unassigned_asset_trackers_${moment().format('YYYY-MM-DDTHH:mm:ss')}`

      const headers = [
        'IMEI',
        'Serial',
        'Make',
        'Model',
        'Firmware',
        'ICCID',
        'Created'
      ]
      const allAssets = await this.getUnassignedAssets()

      const assets = allAssets.map(item => (
        { 
          ...item, 
          created_on: this.formatDate(item.created_on)
        }
      ))
  

      const data = [
        headers,
        [],
        ...assets.map(item => [
          item.imei,
          item.serial_number,
          item.make,
          item.model,
          item.firmware,
          item.ICCID,
          item.created_on
        ])
      ]

      // Create a new workbook
      const wb = xlsx.utils.book_new()

      const ws = xlsx.utils.aoa_to_sheet(data)

        const colWidths = data[0].map((_, colIndex) => {
          const maxLength = data.reduce((max, row) => {
            const cellValue = row && row[colIndex] ? row[colIndex].toString() : ''
            return Math.max(max, cellValue.length)
          }, 0)
          return { width: maxLength + 2 }; // Add a little extra padding
        })

        // Set column widths in the worksheet
        ws['!cols'] = colWidths

        // Append the worksheet to the workbook
        xlsx.utils.book_append_sheet(wb, ws, 'Assets')

        // Write the workbook to a file (e.g., 'example.xlsx')
        xlsx.writeFile(wb, exportSheetName + ".xlsx")
    },

    async downloadAssignedAssets() {
      if(this.orgId.length <= 0) return
      const exportSheetName = `${this.selectedOrg}_assigned_devices_${moment().format('YYYY-MM-DDTHH:mm:ss')}`

      const headers = [
        'IMEI',
        'Serial',
        'Name',
        'Make',
        'Model',
        'Last Seen',
        'Firmware',
        'ICCID'
      ]
      const allAssets = await this.getAllOrgAssets()
      logger.info('downloadAssignedAssets', allAssets)
      const assets = allAssets.map(item => (
        { 
          ...item, 
          last_seen: this.formatDate(this.readValueFromPresenceMap(item, 'last_seen')),
          make: Object.hasOwn(item, 'device_model') ? item.device_model.manufacturer : '',
          model: Object.hasOwn(item, 'device_model') ? item.device_model.model : '',
        }
      ))
  

      const data = [
        headers,
        [],
        ...assets.map(item => [
          item.imei,
          item.serial_number,
          item.assigned_trackable.name,
          item.make,
          item.model,
          item.last_seen,
          item.firmware_version,
          item.iccid
        ])
      ]

      // Create a new workbook
      const wb = xlsx.utils.book_new()

      const ws = xlsx.utils.aoa_to_sheet(data)

        const colWidths = data[0].map((_, colIndex) => {
          const maxLength = data.reduce((max, row) => {
            const cellValue = row && row[colIndex] ? row[colIndex].toString() : ''
            return Math.max(max, cellValue.length)
          }, 0)
          return { width: maxLength + 2 }; // Add a little extra padding
        })

        // Set column widths in the worksheet
        ws['!cols'] = colWidths

        // Append the worksheet to the workbook
        xlsx.utils.book_append_sheet(wb, ws, 'Assets')

        // Write the workbook to a file (e.g., 'example.xlsx')
        xlsx.writeFile(wb, exportSheetName + ".xlsx")
    },

    readValueFromPresenceMap(item, val) {
      if(!item || !val) return ''

      if(!Object.hasOwn(this.assetPresence, item.assigned_trackable.id)) return ''
   
      return this.assetPresence[item.assigned_trackable.id][val]
    },

    getAssetsOrDevices() {
      if(this.dvrType == 'Camera System') {
        this.getDevicesByOrg()
      } else {
        this.getAssetsByOrg()
      }
    },

    async unassignAssetFromDevice() {
      this.unassigningAssets = true

      const unassign = await unassignAssetFromDevice(this.orgId, this.selectedAssetsIds)

      if(unassign && Object.hasOwn(unassign, 'assets_to_unassign')) {
        this.getAssetsByOrg()
        this.unassigningAssets = false
        this.showUnassignAsset = false
      } else {
        this.unassigningAssets = false
      }
    },

    async getAssetsByOrg(page = 1) {
      this.loading = true
      this.devices = []
    

      await Promise.all([
        this.getOrgAssetsPresense(),
        this.getOrgAssets(page, this.selectedGroup)     
      ])
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
    },

    async fetchOrgNodes() {
      this.loadingNodes = true;
      this.vehicles = [];
      this.devices = [];

      const orgTree = await GetOrgTree(this.orgId);
          
      if (orgTree) {
        this.nodes = orgTree;
        this.groups = this.flattenOrgTree([this.nodes.root_node], true)
        this.vehicleGroups = this.flattenOrgTree([this.nodes.root_node]);

        if(this.groups.length > 0) {
          this.selectedGroup = this.groups[0].id
        }

        this.loadingNodes = false
      }
    },
    async getUnassignedAssets() {
      this.loading = true
      this.devices = []

      let assets = await getUnassignedAssets()
      logger.info('assets yo', assets)
      logger.info('unassigned assets ', assets)
      if(Object.hasOwn(assets, 'Devices')) {
        logger.info('should be here')
        this.devices = assets.Devices
        this.loading = false

        return this.devices
      }
      

      this.loading = false
    },

    async getOrgAssetsPresense() {
      const presence = await getOrgAssetsPresense(this.orgId)
      const addLocations = await this.findLocations(presence)

      this.assetPresence = addLocations.reduce((acc, obj) => {
        acc[obj.asset_id] = obj
        return acc;
      }, {})
    },

    async getOrgAssets(page, groupId) {
      const assets = await getOrgAssetDevicesByNode(this.orgId, page, groupId)


      if(assets && Object.hasOwn(assets, 'results')) {
        logger.info('asset devices? ',assets.results)
        this.devices = this.mapAssetDeviceResponse(assets.results)
        this.totalPages = assets.total_pages;
        this.assignedAssetsPaginationInfo.pageNum = assets.page_num;
        this.assignedAssetsPaginationInfo.pageCount = assets.total_pages;
        
        // We need to find the closest option of rows per page from the set list of pagination page size select option will break :(
        const rowOptions = [
          20,
          50,
          100,
          200
        ]
        const targetPageSize = assets.page_size
        const output = rowOptions.reduce((prev, curr) => Math.abs(curr - targetPageSize) < Math.abs(prev - targetPageSize) ? curr : prev);

        this.assignedAssetsPaginationInfo.rowsPerPage = output
      }
    },

    mapAssetDeviceResponse(data) {
      return data.map(item => (
        { 
          ...item, 
          asset_id: item.assigned_trackable.id,
          asset_name: item.assigned_trackable.name,
          asset_make: item.device_model.manufacturer,
          asset_model: item.device_model.model
        }
      ))
    },

    extractDevicesWithAssetId(data) {
      logger.info('extractDevicesWithAssetId called')
      const devicesWithAssetId = [];

      data.forEach(asset => {
        asset.devices.forEach(device => {
          // Clone the device and add asset_id
          devicesWithAssetId.push({
            ...device,
            asset_id: asset.asset_id,
            asset_name: asset.asset_name,
            asset_make: device.make,
            asset_model: device.device_model,
            notes: asset.notes,
            node_name: asset.node_name,
            asset_year: asset.asset_year,
            asset_type: asset.asset_type
          });
        });
      });

      return devicesWithAssetId;
    },

    async getUnassignedDevicesList(page = 1, rows = false) {

      logger.debug("getUnassignedDevices", JSON.stringify({page: page, rows: rows}))

      if(this.loading) {
        return
      }

      // this function is called from the pagination controls in the unassigned devices table. the only way the rows value gets passed up is through this function
      rows = rows || this.unassignedPaginationInfo.rowsPerPage
      this.unassignedPaginationInfo.rowsPerPage = rows

      logger.debug("getUnassignedDevices loading", JSON.stringify({page: page, rows: rows}))

      this.loading = true;

      try {
        let devices = await GetUnassignedDevices(page, rows)
      

        if(devices.Devices) {
          this.devices = devices.Devices
          this.unassignedPaginationInfo.pageNum = devices.page_num;
          this.unassignedPaginationInfo.pageCount = devices.total_pages;
          this.loading = false
        }
        else {
          throw new Error('An error occurred')
        }
      }
      catch (err) {
        logger.debug("getUnassignedDevices load start", page, rows)
        this.loading = false
      }
    },

    // async getUnassignedDevices(page, items = []) {
    //   this.loading = true;

    //   let set = items;
    //   let index = page;
    //   let devices = await GetUnassignedDevices(page)
      
      
    //   if(devices.Devices) {
    //     for (let device in devices.Devices) {
    //       set.push(devices.Devices[device]);
    //       this.devices.push(devices.Devices[device])
    //     }

    //     if (devices.Devices.length >= 50) {
    //       index++;

    //       this.getUnassignedDevices(index, set);
    //     } else {
    //       this.loading = false;
    //     }
    //   }
    //   else {
    //     this.loading = false;
    //   }
    // },


    refreshDevices() {
      this.clearSelection++
      this.selectedAssets = []

      if(this.search.length > 0) {
        if(this.dvrType == 'Asset Tracker') {
          this.searchAssets()
        }
        else {
          this.searchDevices()
        }
      }
      else {
        if(this.dvrType == 'Camera System') {
          if (this.deviceType == 'Unassigned') {
            logger.info('unassign camera')
            this.getUnassignedDevicesList()
          }
          else {
            if (this.selectedOrg.length > 0) {
              this.getDevicesByOrg();
            }
          }
          /*
          if (this.deviceType == 'Unassigned') {
            this.devices = [];
            this.getUnassignedDevicesList()
          }
          */
        }
        else {
          if (this.deviceType == 'Unassigned') {
            this.getUnassignedAssets()
          }
          else {
            if (this.selectedOrg.length > 0) {
              this.getAssetsByOrg()
            }
          }
        }

        const orgId = this.retrunOrgID(this.selectedOrg);
        this.setOrgToWatch(orgId);
      }
      
    },
    retrunOrgID(name) {
      let org = this.orgs.find(org => {
        return org.name == name;
      });

      return org ? org.id : '';
    },
    launchRowAction(e) {
      let allOptions = document.querySelectorAll(".report-action-options");

      for (let option of allOptions) {
        option.classList.remove('active-options');
        if (option === e.target.nextSibling) {
          option.classList.toggle('active-options');
        } 
      }
    },
    toggleAssignmentComp() {
      this.showDeviceAssignment = !this.showDeviceAssignment;
    },
    toggleAssetAssignmentComp() {
      logger.info('toggleAssetAssignmentComp')
      this.showAssetAssignment = !this.showAssetAssignment
    },
    setSelectedVehicle(item) {
      let vehicle = this.vehicles.find(vehicle => {
        return vehicle.devices.some((device) => {
          return device.device_id == item.id;
        });
      })

      this.selectedVehicle = [vehicle];
      this.toggleInfoModal();
    },
    showInfoModal(item) {
      this.selectedVehicleDevice = [item];
      this.toggleInfoModal();
    },
    toggleInfoModal() {
      this.vehicleDeviceConfig = !this.vehicleDeviceConfig;
    },
    setUnassignTarget(item) {
      this.unassignRes = null;
      this.unassignTarget = item;
      this.toggleUnassignPrompt();
    },
    toggleUnassignPrompt() {
      this.displayUnassignPrompt = !this.displayUnassignPrompt;
    },
    setUpdateOTCTarget(item) {
      this.updateRes = null;
      this.updateOTCTarget = item;
      this.toggleUpdateOTC();
    },
    toggleUpdateOTC() { 
      this.displayUpdateOTC = !this.displayUpdateOTC;
    },
    setDeleteDeviceTarget(item, type) {
      logger.info('device type for deletion',item, type)
      this.deleteRes = null;
      this.deleteDeviceTarget = item;
      // Sets the state to either unassigned or pending
      this.deleteDeviceTarget.state = type;
      this.toggleDeleteDevicePrompt();
    },
    toggleDeleteDevicePrompt() {
      this.displayDeleteDevice = !this.displayDeleteDevice;
    },
    async unassignDevice() {
      this.unassignState = false;

      let vehicleId = '';
      let deviceId = this.unassignTarget.id;
      let orgId = this.retrunOrgID(this.selectedOrg);
      
      logger.info('unassign device : ', orgId, vehicleId, deviceId);

      const unasign = await UnassignDeviceFromVehicle(orgId, vehicleId, deviceId);

      if (unasign) {
        this.refreshDevices();

        this.unassignRes = {
          msg: 'Device Unassigned Successfully',
          code: 'green'
        }
      } else {
        this.unassignRes = {
          msg: 'Device Unassignment Failed',
          code: 'red'
        }
      }
      this.unassignState = true;
      this.unassignTarget = {};
    },
    async regenOTC() {
      this.updateState = false;

      let id = this.updateOTCTarget.id;

      const update = await RegenerateOTC(id);

      if (update) {
        this.refreshDevices();

        this.updateRes = {
          msg: `Updated OTC : ${update.otc}`,
          code: 'green'
        }
      } else {
        this.updateRes = {
          msg: 'OTC Regeneration failed',
          code: 'red'
        }
      }

      this.updateState = true;
      this.updateOTCTarget = {}
    },
    async deleteDevice() {
      this.deleteState = false;

      let id = this.deleteDeviceTarget.id;
      let deleteItem = null;

      if(this.deleteDeviceTarget.state == 'pending') {
        deleteItem = await DeletePendingDevice(id);
      }
      if(this.deleteDeviceTarget.state == 'unassigned') {
        deleteItem = await DeleteUnassignedDevice(id);
      }

      if (deleteItem) {
        this.refreshDevices();
        
        this.deleteRes = {
          msg: 'Device Deleted Successfully',
          code: 'green'
        }
      } else {
        this.deleteRes = {
          msg: 'Device Deletion failed',
          code: 'red'
        }
      }

      this.deleteState = true;
      this.deleteDeviceTarget = {}
    },
    selectionUpdated(data) {
      this.selectedDevices = data;
    },
    selectionUpdatedAssets(data) {
      logger.info('selectionUpdatedAssets', data)
      this.selectedAssets = data
    },
    deviceSelectedForInstall(data) {
      logger.info('deviceSelectedForInstall : ', data);
    },

    flattenOrgTree(node, returnObject = false) {
      var result = [];
      
      node.forEach((node) => {
        if(returnObject) {
          logger.info('node', node)
          result.push({
            name: node.metadata.label,
            id: node.id
          });
        }
        else {
          logger.info('node', node)
          result.push(node.metadata.label);
        }
          
        if (Array.isArray(node.nodes)) {
          result = result.concat(this.flattenOrgTree(node.nodes, returnObject));
        }
      });
      return result;
    },

    returnVehicleGroup(id, node) {
      let result;

      if (Object.values(node).indexOf(id) > -1) {
        return node;
      } else {
        for (var i = 0; i < node.nodes.length; i += 1) {
          let subNode = node.nodes[i];
          
          result = this.returnVehicleGroup(id, subNode);

          if (result !== false) {
              return result;
          }
        }
        return false;
      }
    },
    downloadFile () {
      if (this.devices.length > 0) {
        // create our excel file
        const wb = xlsx.utils.book_new();
        
        // Filter unwanted fields from report
        let cleanedReportCollection = [];


        this.devices.forEach(item => {
          let cleanedReportItem = {};
          let tableHeaders = this.tableHeadings[this.deviceType].headers;

          tableHeaders.forEach(heading => {
            let key = heading.value;

            // eslint-disable-next-line no-prototype-builtins
            if (item.hasOwnProperty(key)) {             
              cleanedReportItem[key] = item[key];
            }
  
            if(!cleanedReportCollection.includes(cleanedReportItem)) {
              cleanedReportCollection.push(cleanedReportItem);
            }
          });
        });

        // create our worksheets
        const report = xlsx.utils.json_to_sheet(cleanedReportCollection);

        // apend them to the workbook
        xlsx.utils.book_append_sheet(wb, report, this.reportTitle);

        const reportName = `${this.deviceType}_${this.selectedOrg}_${moment().format("YYYY-MM-DD HH:mm:ss")}`;
        xlsx.writeFile(wb, reportName + ".xlsx");
      }
    }
  },
}
</script>

<style lang="scss">
  .device-management {
    padding: 1em 0;
    .device-control-bar {
        padding: 0 1em;
    }
    .refresh-devices {
      &:hover {
        cursor: pointer;
      }
    }
    .download-container {
      text-align: right;
      padding-right: 1em;
      .download-icon {
        &:hover {
          cursor: pointer;
        }
      }
    }
    .reports-action-launch {
      position: relative;
      cursor: pointer;
    }
    .report-action-options {
      display: none;
    }
    .active-options {
      display: block !important;  
    }
  }
  .grey-bg {
    background: rgba(0, 0, 0, 0.05);
  }
  .error-message {
    color: #f44336;
    text-align: center;
    width: 100%;
  }
  .device-label {
    color: rgb(14, 118, 191);
  }
  .asset-notes {
    width: 200px;
  }
  .asset-map {
    margin-top: -12px;
    position: relative;
    height: 500px;
    width: 100%;
  }
  .v-data-table__wrapper {
    overflow-x: visible !important;
    overflow-y: visible !important;
  }
</style>